import { FunctionalComponent, h } from 'preact';
import { get as _get } from 'lodash';
import { useCallback } from 'preact/hooks';
import { BringgFontIcons } from '@bringg/bringg-icons';
import SideNav, { ButtonsConfig } from '../../../components/side-nav/side-nav';
import MerchantLogo from '../../../components/merchant-logo/merchant-logo';
import { useTranslation } from '../../../hooks/use-translation';
import { useStore } from '../../../helpers/use-store';
import { isScheduleShareType } from '../../../helpers/sharing-type-helper';
import TrackingStore from '../../../stores/tracking/tracking-store';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	merchantLogoUrl: string;
	openSideNav: () => void;
}

const SharedLocationSideNav: FunctionalComponent<Props> = ({ isOpen, onClose, merchantLogoUrl, openSideNav }) => {
	const { sharedLocationStore } = useStore();
	const { t } = useTranslation();

	let buttonsConfig: ButtonsConfig;

	const handleShareLocation = useCallback(async () => {
		const trackingStore: TrackingStore = sharedLocationStore.getActiveTrackingStore();
		await trackingStore.shareUserLocation();
		onClose();
	}, [sharedLocationStore]);

	const sharedType = _get(sharedLocationStore.sharedLocationConfig, 'shared_type');
	const displayType = _get(sharedLocationStore.sharedLocationConfig, 'display_type');
	const shareLocationEnabled = _get(sharedLocationStore.sharedLocationConfig, 'support_find_me', false);
	const forwardEnabled = _get(sharedLocationStore.sharedLocationConfig, 'task_forwarding_enabled', false);

	if (forwardEnabled) {
		buttonsConfig = {
			...buttonsConfig,
			forward: {
				text: t('FORWARD.THIS_ORDER'),
				icon: BringgFontIcons.Forward,
				onClick: sharedLocationStore.forwardMode
			}
		};
	}

	if (shareLocationEnabled && !isScheduleShareType({ sharedType, displayType })) {
		buttonsConfig = {
			...buttonsConfig,
			share: {
				text: t('SHARING_MY_LOCATION'),
				icon: BringgFontIcons.MyLocation,
				onClick: handleShareLocation,
				loadingConfig: {
					icon: BringgFontIcons.Loader,
					text: t('SHARING_LOADING')
				}
			}
		};
	}

	if (!buttonsConfig) {
		openSideNav();
	}

	return (
		buttonsConfig && (
			<SideNav
				header={
					<MerchantLogo className="shared-location-side-nav-merchant-log" merchantLogoUrl={merchantLogoUrl} />
				}
				isOpen={isOpen}
				buttonsConfig={buttonsConfig}
				onClose={onClose}
			/>
		)
	);
};

export default SharedLocationSideNav;
